import { combineReducers } from 'redux';

import resolver from '../resolvers/organiser';

import byId, * as organisersById from './byId';
import bySelection, * as organiserSelected from './bySelection';

const objects = ['ORGANISER', 'ORGANISERS'];

/**
 * Reducers for all state relating to organisers.
 * Organisers are stored as full objects within the byId reducer.
 * The selected reducer holds the ID and query state of the current selected organiser.
 */
const organisers = combineReducers({
  byId: byId(...objects),
  selected: bySelection(objects[0]),
});

export default organisers;

// Get an organiser by ID
export const getOrganiser = (state, id) => resolver(organisersById.getById(state.byId, id));

// Get the ID of selected organiser
export const getSelectedId = state => organiserSelected.getId(state.selected);

// Get the error state of selected organiser request
export const getSelectedError = state => organiserSelected.getError(state.selected);

// Get the fetching state of selected organiser request
export const getSelectedFetching = state => organiserSelected.getFetching(state.selected);



// WEBPACK FOOTER //
// ./app/src/state/reducers/organisers.js